import { createAction, props } from '@ngrx/store';
import { ITasksQueueState } from './tasks-queue.types';

const getType = (actionType: string) => `[Tasks Queue] ${actionType}`;

export const addTask = createAction(
  getType('Add task'),
  props<{ taskType: ITasksQueueState['tasks'][0]['type'], params: ITasksQueueState['tasks'][0]['params'] }>(),
);

export const removeTask = createAction(
  getType('Remove task'),
  props<{ taskType: ITasksQueueState['tasks'][0]['type'] }>(),
);
